<div #top id="top"></div>
<app-header></app-header>
<div style="min-height: 90vh;">
    <router-outlet (activate)="onActivate($event)"></router-outlet>
</div>
<app-footer></app-footer>